import { Card } from "@progress/kendo-react-layout";
import "./customcard.css";

interface CustomCardProps {
    children: any
}

export default function CustomCard(props: CustomCardProps) {
    return <Card className="custom-card-panelbar-wrapper card-container">
        <div className="card">
            {props.children}
        </div>
    </Card>;
}